// extracted by mini-css-extract-plugin
export default {"root":"PlasmicGenericButton_root__YZgQu","slotTargetChildren":"PlasmicGenericButton_slotTargetChildren__8QvjA"};